import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { ToolsFormComponent } from '../tools-form/tools-form.component';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Site } from 'src/app/models/site.model';
import { ApiService } from 'src/app/services/http/api.service';
import { Tool } from 'src/app/models/tool.model';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ToolImportFormComponent } from '../tools-import-form/tools-import-form.component';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";

@Component({
  selector: 'app-tools-component',
  templateUrl: './tools.component.html'
})
export class ToolsComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
  @ViewChild("container", { read: ViewContainerRef })
  public container: ViewContainerRef | undefined;
  public gridData: Tool[] = [];
  public gridView: any[] = [];
  public filter: CompositeFilterDescriptor | undefined;
  public mySelection: string[] = [];
  public isChecked: boolean = false;
  public customMsgService: CustomMessagesService;

  constructor(public msgService: MessageService, private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.allData = this.allData.bind(this);
  }

  public ngOnInit(): void {
    this.load();
  }

  // Update Grid collection during changing My Team/All Team
  public onTeamChange(pageSize: number): void {
    pageSize === 25
      ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
      : (this.gridView = this.gridData.slice(0, pageSize));
  }

  public onFilter(inputValue: string): void {
    this.gridView = process(this.gridData, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: this.getField,
            operator: 'contains',
            value: inputValue
          }
        ]
      }
    }).data;

    this.dataBinding ? this.dataBinding.skip = 0 : null;
  }

  public getField = (args: Tool) => {

    //  abatida dataItem.bloqueada
    let condicao = 'ativa';
    let avaria = 'nenhuma'
    let abatida = 'pendete';

    if (args.abatida)
      abatida = 'abatida'

    if (args.bloqueada)
      condicao = 'bloqueada'

    if (args.avariada)
      avaria = 'avariada'

    return `${args.marca}_${args.identificacao}_${condicao}_${avaria}_${abatida}_${args.estadoDescricao}_${args.modelo}_${args.nomeTipoFerramenta}_${args.nomeSubTipoFerramenta}_${args.numeroDeSerie}_${args.descricao}_${args.cartaoUtilizadorNaPosse}`;
  }


  public open(): void {


    const dialogRef: DialogRef = this.dialogService.open({

      title: this.customMsgService.translate('btnCriar') + " " + this.customMsgService.translate('tool'),
      // Show component
      content: ToolsFormComponent
    });

    dialogRef.result.subscribe((result) => {
      this.load();
    });
  }

  public openEdit(c: Tool): void {


    const dialogRef: DialogRef = this.dialogService.open({

      title: this.customMsgService.translate('btnEditar') + " " + this.customMsgService.translate('tool'),
      // Show component
      content: ToolsFormComponent
    });


    const userInfo = dialogRef.content.instance as ToolsFormComponent;
    userInfo.formValue = c;
    userInfo.setFormValues();

    dialogRef.result.subscribe((result) => {
      this.load();
    });
  }

  canList() {
    return User.canFerramentasList();
  }

  canCreate() {
    return User.canFerramentasCreate();
  }

  canDelete() {
    return User.canFerramentasDelete();
  }

  canEdit() {
    return User.canFerramentasEdit();
  }

  public upload() {

    const dialogRef: DialogRef = this.dialogService.open({

      title: this.customMsgService.translate('importarFerramentas'),
      // Show component
      content: ToolImportFormComponent
    });
    dialogRef.result.subscribe((result) => {
      this.gridView = this.gridData;
      this.load();
    });
  }

  public delete(e: Site): void {
    var sim = this.customMsgService.translate('yes');
    var nao = this.customMsgService.translate('no');
    const dialog: DialogRef = this.dialogService.open({
      appendTo: this.container,
      title: this.customMsgService.translate('confirmacao'),
      content: this.customMsgService.translate('desejaRemover'),
      actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
      width: 450,
      height: 200,
      minWidth: 250,
    });
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
      } else if (result.text == sim) {
        this.api.cruddelete<BaseHttpResult>('Ferramentas', e.id).
          then(res => {
            if (res.ok) {
              this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('registoApagadoComSucesso'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
              });
              this.load();
            } else {
              this.notificationService.show({
                appendTo: this.container,
                content: res.message,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
              });
            }
          }).
          catch(err => {
          });
      }
    });
  }

  load() {
    this.gridView = this.gridData;
    this.api
      .getRequest<BaseHttpResponse<Tool[]>>("Ferramentas/GetFerramentas?abatidas=" + this.isChecked)
      .then((data) => {
        this.gridData = data.value;
        this.gridView = this.gridData;
      })
      .catch((err) => { });
  }

  public checkValue() {
    this.load();
  }

  public allData(): ExcelExportData {

    const result: ExcelExportData = {
      data: process(this.gridView, { filter: this.filter }).data,

    };

    return result;
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.gridData = filterBy(this.gridView, filter);
  }

}

